var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearLineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 5.72C16.3 9.14 13.87 13.98 16.5 17.07C16.83 13.28 17.17 9.5 17.5 5.72C20.83 5.72 24.15 5.72 27.48 5.72C27.48 12.53 27.48 19.34 27.48 26.15C25.83 26.15 24.19 26.15 22.54 26.15C22.2 23.74 21.85 21.34 21.5 18.93C21.17 21.36 20.83 23.79 20.5 26.21C17.5 26.21 14.5 26.21 11.5 26.21C11.17 23.48 10.83 20.76 10.5 18.03C10.17 20.74 9.83 23.44 9.5 26.15C7.88 26.15 6.26 26.15 4.65 26.15C4.65 19.34 4.65 12.53 4.65 5.72C7.94 5.72 11.23 5.72 14.53 5.72Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#ffffff",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 0.06C14.58 0.06 17.45 0.06 20.33 0.06C21.01 1.6 25.48 2.78 26.97 4.23C28.36 5.58 31.16 11.33 31.94 11.67C31.94 14.55 31.94 17.42 31.94 20.3C31.22 20.6 28.28 26.41 26.91 27.75C25.38 29.24 20.71 30.38 20 31.94C17.34 31.94 14.68 31.94 12.02 31.94C11.33 30.37 6.66 29.24 5.13 27.71C3.81 26.38 0.56 20.19 0.06 19.97C0.06 17.32 0.06 14.66 0.06 12C0.75 11.68 3.7 5.62 5.09 4.25C6.56 2.78 11.06 1.58 11.7 0.06ZM14.53 5.72C11.23 5.72 7.94 5.72 4.65 5.72C4.65 12.53 4.65 19.34 4.65 26.15C6.26 26.15 7.88 26.15 9.5 26.15C9.83 23.44 10.17 20.74 10.5 18.03C10.83 20.76 11.17 23.48 11.5 26.21C14.5 26.21 17.5 26.21 20.5 26.21C20.83 23.79 21.17 21.36 21.5 18.93C21.85 21.34 22.2 23.74 22.54 26.15C24.19 26.15 25.83 26.15 27.48 26.15C27.48 19.34 27.48 12.53 27.48 5.72C24.15 5.72 20.83 5.72 17.5 5.72C17.17 9.5 16.83 13.28 16.5 17.07C13.87 13.98 16.3 9.14 14.53 5.72Z",
    fill: "#875aed",
    fillRule: "evenodd",
    stroke: "#875aed",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearLineLogo);
export default __webpack_public_path__ + "static/media/ClearLineLogo.a74869f50ffcdc5d9fdf723b01dbdb28.svg";
export { ForwardRef as ReactComponent };